// extracted by mini-css-extract-plugin
export default {"container":"OrderStatusCell_container__hd6GR"};